<template>
  <div class="clearfix">
    <div class="bookmark-folder">
      <div class="info-header">
        <div class="mb-1 t-600 info-header__bookmark-name">
          <i class="fa mr-2" :class="{ 'fa-unlock t-green': !bookmarkFolder.is_private, 'fa-lock t-red': bookmarkFolder.is_private }" />
          <h3>
            <template v-if="noRedirect">
              {{ bookmarkFolder.name }}
              <span class="t-xs t-secondary t-400">({{ bookmarkFolder.count }} {{ 'item' | pluralize(bookmarkFolder.count)}})</span>
            </template>
            <router-link
              v-else
              :to="{ name: 'researcher.bookmark_folders.show', params: { bookmark_folder: bookmarkFolder.slug_values[0] } }"
            >{{ bookmarkFolder.name }}
              <span class="t-xs t-secondary t-400">({{ bookmarkFolder.count }} {{ 'item' | pluralize(bookmarkFolder.count)}})</span>
            </router-link>
          </h3>
        </div>
        <div v-if="canEdit" class="actions" :class="{ 'show-on-hover': !noRedirect }">
          <bookmark-folder-actions
            :bookmarkFolder="bookmarkFolder"
            :user="user"
            :parentView="noRedirect ? 'Folder' : 'List'"
          />
        </div>
      </div>

      <p class="t-secondary t-sm mb-0 t-semi-compact">
        <span>{{ bookmarkFolder.description || `This bookmark folder has no description` }}</span>
      </p>

      <ul v-if="showTags && !isEmpty(bookmarkFolder.tags)" class="mb-0 mt-2 list-inline">
        <li v-for="(tag, index) in bookmarkFolder.tags" :key="index" class="list-inline-item mr-0 pr-1">
          <span class="badge badge-pill badge-secondary--blue bd-radius mr-2">
            {{ tag }}
          </span>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
import BookmarkFolderActions from '@/components/user/bookmark_folder/Actions'

export default {
  name: 'bookmarkItem',
  components: {
    BookmarkFolderActions
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    researcher: {
      type: Object,
      required: true
    },
    bookmarkFolder: {
      type: Object,
      required: true
    },
    showTags: {
      type: Boolean,
      required: false
    },
    noRedirect: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    canEdit () {
      return this.$can.edit('researcher', this.user.rw_access)
    }
  }
}
</script>
